import getIn from 'lodash/get';
import noop from 'lodash/noop';
import { push } from 'react-router-redux';
import { call, put, select } from 'redux-saga/effects';

import * as AppActions from '../actions';
import * as AppConstants from '../constants';
import { getInDomain } from '../domains/externalUtils';
import * as AppErrors from '../lib/error';
import * as RouteUtils from '../lib/RouteUtils';
import { putAndWait } from '../sagas/TaskManager';
import Logger from '../tools/Logger';
import * as AppUtils from '../utils';

const log = Logger.child({ component: 'mediator/handlers' });

export function* pauseTrack({ payload }) {
  if (!payload.track) {
    // eslint-disable-next-line require-atomic-updates
    payload.track = yield select(
      getInDomain('playback.utils.getCurrentTrackFromActivePlaylist', null),
    );
  }
  yield call(putAndWait, { type: 'CHECK_STREAM_VIOLATION' });

  const isAPS = yield select(getInDomain('playback.utils.isPlaylistModelTypeAPSItem', false));
  if (isAPS) {
    yield put(getInDomain('playback.actions.pauseSource')());
  } else {
    yield put(
      getInDomain('playback.actions.updateServerPlaybackPaused')(payload.callPlaybackPaused),
    );
  }

  yield call(putAndWait, AppActions.AudioPlayer.pauseAudio(payload));
  const type = yield select(getInDomain('playback.utils.getCurrentPlaylistType'));
  getIn(
    window,
    'DesktopBridge.playOrPauseMedia',
    noop,
  )(false, AppUtils.SourceType.getDesktopBridgeSourceType(type));
}

export function* addReplayTrackToPlaylist(action) {
  // TODO-PAYLOAD: WEBCA-2505
  if (!action.payload) {
    action.payload = action.data;
  }

  if (!action.payload.track) {
    throw new AppErrors.ApplicationError(
      AppConstants.Playback.PlaybackErrors.GET_REPLAY_TRACK_FAILED,
    );
  }
  yield call(putAndWait, {
    type: 'SIGNAL_SMART_CONVERSION_OPPORTUNITY',
    payload: { triggerAction: action.type },
  });
  try {
    yield call(putAndWait, {
      type: 'GET_AND_ADD_REPLAY_TRACK',
      data: action.payload,
    });
  } catch (e) {
    throw new AppErrors.ApplicationError(
      AppConstants.Playback.PlaybackErrors.GET_REPLAY_TRACK_FAILED,
    );
  }
}

export function* promptStreamViolation(action) {
  const triggerAction = action.data?.triggerAction;
  // In the case of sim stream violation on intercepting a station start,
  // The action will already be replayed
  let shouldStartStation = true;
  if (triggerAction && triggerAction.type === 'START_STATION') {
    shouldStartStation = false;
  }
  try {
    yield call(putAndWait, AppActions.UseCases.pauseTrack({ isSimStreamViolation: true }));
    yield call(putAndWait, {
      type: 'OPEN_SIM_STREAM_MODAL',
      data: { shouldStartStation },
    });
    // If no errors thrown by here, means listener chose to keep listening
    if (triggerAction) {
      yield put(triggerAction);
    }
  } catch (error) {
    if (!(error instanceof AppErrors.TaskManagerError)) {
      throw error;
    }
    const simStreamError = error.getFirstErrorOfType(AppErrors.SimStreamError);
    if (simStreamError) {
      if (triggerAction) {
        // if user rejects stream hijack on station start and she is on the now playing view
        // redirect to mystations
        const isStartStationAction = triggerAction.type === 'STATION_START';
        if (isStartStationAction && (yield select(AppUtils.UIState.getIsNowPlayingOpen))) {
          yield put(push(AppUtils.Route.getMyStationsPath()));
        }
      } else {
        throw simStreamError;
      }
    }
  }
}

export function* getRedirectRefererUrl() {
  const referer = yield select(AppUtils.Application.getCustomRedirectReferer);
  if (AppUtils.Url.isValidUrl(referer)) {
    const url = new URL(referer);
    url.hostname = 'community.pandora.com';
    return url.href;
  }

  return '';
}

export function* navigateToCommunity(action) {
  const ssoUrl = AppUtils.Application.getCommunitySSOUrl();
  const atCookie = AppActions.UserAccount.getAtCookie();
  const auth_token = atCookie || (yield select(AppUtils.Listener.getAuthToken));
  const referer = yield call(getRedirectRefererUrl);
  const refererParam = referer ? `&referer=${encodeURIComponent(referer)}` : '';
  const userAgent = encodeURIComponent(navigator.userAgent);

  let url = `${ssoUrl}?userAgent=${userAgent}${refererParam}`;

  if (auth_token) {
    const encodedToken = encodeURIComponent(auth_token);
    url = `${url}&auth_token=${encodedToken}`;
  }

  log.info(`navigateToCommunity(${JSON.stringify(action)} ): ${url}`);

  yield call(RouteUtils.navigate, url, action.payload.openWindow);
}
